import { Component, Vue, Prop } from 'vue-property-decorator';
import TelstraUIVueSvg from '../TelstraUIVueSvg/TelstraUIVueSvg.vue';

@Component({
  components: {
    TelstraUIVueSvg,
  },
})
export default class TelstraUIVueTooltip extends Vue {
  @Prop({ required: true }) text!: string;

  isActive: boolean = false;

  tooltipChange(isActive: boolean): void {
    this.isActive = isActive;
  }

  tooltipClose(): void {
    (this.$refs.tooltipRef as any).callDeactivate();
  }
}
